import script from "./Aside.vue?vue&type=script&lang=ts&setup=true"
export * from "./Aside.vue?vue&type=script&lang=ts&setup=true"

import "./Aside.vue?vue&type=style&index=0&id=7545cf57&lang=css"

const __exports__ = script;

export default __exports__